<template>
    <div>
        <v-dialog v-model="dialog" persistent max-width="700">
            <v-card>
                <v-container>
                    <v-card-title>
                        <span class="overline">インテリアパース依頼内容</span>
                        <v-spacer></v-spacer>
                        <v-icon dark @click="toggleDialogHousePresentationInt(false)">mdi-close</v-icon>
                    </v-card-title>
                    <v-container>
                        <!-- <v-stepper v-model="stepInt" vertical>
                            <v-container>
                                STEP 1
                                <template>
                                    <v-stepper-step step="1" color="#455a64">
                                        <span class="caption font-weight-black">依頼パターン数を入力してください</span>
                                    </v-stepper-step>
                                    <v-stepper-content step="1">
                                        <v-container>
                                            <v-autocomplete
                                                v-model="reqPattern" 
                                                dense
                                                outlined
                                                :items="[1,2,3]"
                                                @change="insertingHousePresentationIntContent()"
                                                clearable>
                                            </v-autocomplete>
                                        </v-container>
                                    </v-stepper-content>
                                </template>

                                STEP 2
                                <template>
                                    <v-stepper-step :complete="stepInt > 2" step="2" color="#455a64">
                                        <span class="caption font-weight-black">インテリアパース依頼</span>
                                    </v-stepper-step>
                                    <v-stepper-content step="2">
                                        <template>
                                            <v-row>
                                                <v-col cols="8">
                                                    <v-simple-table class="mainTable colorView">
                                                        <thead>
                                                            <tr>
                                                                <th style="width:50px !important; text-align:left !important;"></th>
                                                                <th v-for="(count, i) in reqPattern" :key="i" style="width:150px !important;">
                                                                    {{ `パ一タン - ${count}` }}
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <th style="width: 50px !important; text-align: center !important">階</th>
                                                                <td v-for="(count,i) in reqPattern" :key="i">
                                                                    <v-edit-dialog
                                                                        :return-value.sync="patterns[count]">
                                                                        <v-tooltip bottom>
                                                                            <template v-slot:activator="{ on }">
                                                                                <span v-on="on"> {{ patterns[count].floor }} </span>
                                                                            </template>
                                                                            <span> {{patterns[count].floor}} </span>
                                                                        </v-tooltip>
                                                                    <template v-slot:input>
                                                                        <small class="overline" > 階 </small>
                                                                        <v-autocomplete
                                                                            v-model="patterns[count].floor"
                                                                            outlined
                                                                            dense
                                                                            rows="2"
                                                                            :items="floorSelection">
                                                                        </v-autocomplete>
                                                                    </template>
                                                                    </v-edit-dialog>
                                                                </td>
                                                            </tr>

                                                            <tr>
                                                                <th style="width: 50px !important; text-align: center !important">部屋名記号</th>
                                                                <td v-for="(count,i) in reqPattern" :key="i">
                                                                    <v-edit-dialog
                                                                        :return-value.sync="patterns[count]">
                                                                        <v-tooltip bottom>
                                                                            <template v-slot:activator="{ on }">
                                                                                <span v-on="on"> {{ patterns[count].layout }} </span>
                                                                            </template>
                                                                            <span> {{patterns[count].layout}} </span>
                                                                        </v-tooltip>
                                                                    <template v-slot:input>
                                                                        <small class="overline" > 階 </small>
                                                                        <v-autocomplete
                                                                            v-model="patterns[count].layout"
                                                                            item-text="name"
                                                                            item-value="name"
                                                                            outlined
                                                                            dense
                                                                            rows="2"
                                                                            :items="FLOOR_LAYOUT">
                                                                        </v-autocomplete>
                                                                    </template>
                                                                    </v-edit-dialog>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </v-simple-table>
                                                </v-col>
                                            </v-row>
                                        </template>
                                    </v-stepper-content>
                                </template>
                            </v-container>
                        </v-stepper> -->
                        
                        <v-col cols="12" class="mt-3">
                            <span class="caption font-weight-black"><v-icon :color="reqPattern != null ? '#455a64' : '#989898'">mdi-numeric-1-circle</v-icon>&nbsp;&nbsp;依頼パターン数を入力してください</span><br>
                                <span style="color:red;font-size:12px;" class="ml-4">※インテリアパースの視点位置及び視点方向を記載した書類を別途お送りください。</span><br>
                                <span style="color:red;font-size:12px;" class="ml-4">※トライアルエリア以外での依頼は不可</span>
                            <v-autocomplete
                                v-model="reqPattern"
                                dense
                                outlined
                                :items="[1,2,3]"
                                name="house_presentation_pattern"
                                label=""
                                clearable
                                class="mt-2">
                            </v-autocomplete>
                        </v-col>
                        

                    </v-container>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn dark color="success" medium v-show="reqPattern != null" @click="storeInt()"  style="width:10%;">保存</v-btn>
                        <v-btn dark color="red" medium @click="closeInt()" style="width:10%;">戻る</v-btn>
                        <!-- <v-btn dark color="red" medium @click="stepInt--" v-show="stepInt == 2" style="width:10%;">戻る</v-btn>s -->
                    </v-card-actions>
                </v-container>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
    props : {
        dialog : Boolean
    },

    data() {
        return {
            // stepInt: 1,
            reqPattern: null,
            // patterns : {
            //     1: {floor: null, layout: null},
            //     2: {floor: null, layout: null},
            //     3: {floor: null, layout: null},
            // },
            // floorSelection: [
            //     "1階",
            //     "2階",
            //     "3階",
            //     "R階",
            // ]

        }
    },

    methods: {
        ...mapActions([
            // '_getFloorLayout'
        ]),

        toggleDialogHousePresentationInt(value){
            this.$emit('toggleDialogHousePresentationInt',value)
        },

        // proceedNext(){
        //     this.stepInt++;
        // },

        storeInt(){
            this.$emit('storeInt', this.reqPattern)
            this.toggleDialogHousePresentationInt(false);
            // console.log(this.reqPattern,'reqPattern')
            // if(!this.$store.state.editMode) {
            //     for(let i = 0; i < this.cad_request_house_presentation_int.length; i++){
            //         console.log(this.patterns[i+1],'FOR EACH')
            //         if(this.patterns[i+1]) {
            //             this.cad_request_house_presentation_int[i].floor = this.patterns[i+1].floor;
            //             this.cad_request_house_presentation_int[i].layout = this.patterns[i+1].layout;
            //             console.log(this.cad_request_house_presentation_int,'test')
            //         }else{
            //             alert('Please fill out all fields!')
            //             return false;
            //         }
            //     }
            // } else {
            //     for(let i = 0; i < this.edit_cad_request_house_presentation_int.length; i++) {
            //         console.log(this.patterns[i+1],'EDIT FOR EACH')
            //         if(this.patterns[i+1]) {
            //             this.edit_cad_request_house_presentation_int[i].floor = this.patterns[i+1].floor;
            //             this.edit_cad_request_house_presentation_int[i].layout = this.patterns[i+1].layout;
            //             console.log(this.edit_cad_request_house_presentation_int,'test edit')
            //         } else {
            //             alert('Please fill out all fields!')
            //             return false;
            //         }
            //     }
            // }
        },

        closeInt(){
            this.reqPattern = null;
            this.$emit('closeInt', null)
            this.toggleDialogHousePresentationInt(false);
        },
        
        // insertingHousePresentationIntContent(){
        //     if(!this.$store.state.editMode){
        //         for(let i = 0; i < this.reqPattern; i++) {
        //             let data = {
        //                 cad_request_id : null,
        //                 revision : null,
        //                 house_type_id : null,
        //                 floor : null,
        //                 layout : null,
        //             }
        //             this.cad_request_house_presentation_int.push(data)
        //             data = {}
        //         }
        //     } else {
        //         for(let i = 0; i < this.reqPattern; i++) {
        //             let data = {
        //                 cad_request_id : null,
        //                 revision : null,
        //                 house_type_id : null,
        //                 floor : null,
        //                 layout : null,
        //             }
        //             this.edit_cad_request_house_presentation_int.push(data)
        //             data = {}
        //         }
        //     }
        // },


    },

    computed: {
        ...mapState([
            // 'FLOOR_LAYOUT',
            'cad_request_house_presentation_int',
            'edit_cad_request_house_presentation_int',
            'editMode',
            'editRevision',
            'editCadRequestRevisionContent',
            'cadRequestRevisionContent',
            'existingRevisions',
        ])
    },

    mounted() {
        // this._getFloorLayout();
    },

    watch : {
        dialog(val) {
            // if(!val){
                // this.patterns[1].floor = null
                // this.patterns[1].layout = null
                
                // this.patterns[2].floor = null
                // this.patterns[2].layout = null

                // this.patterns[3].floor = null
                // this.patterns[3].layout = null

                // this.reqPattern = null
                // this.stepInt = 1
            // }  else {

            // }

        // if(this.$store.state.edit_cad_request_house_presentation_int){
        //     if(this.$store.state.edit_cad_request_house_presentation_int.length != 0){
        //         this.reqPattern = this.edit_cad_request_house_presentation_int.length
        //             if(this.reqPattern){
        //                 this.stepInt++
        //                 for(let i = 1; i <= this.edit_cad_request_house_presentation_int.length; i++) {
        //                     this.patterns[i].floor = this.edit_cad_request_house_presentation_int[i-1].floor;
        //                     this.patterns[i].layout = this.edit_cad_request_house_presentation_int[i-1].layout;
        //                 }
        //             }
        //     }
        // }

        },
    },
}
</script>

<style scoped>
.v-data-table.colorView th {
    border: 1px solid black;
    border-left: 1px solid black !important;
    border-right: 1px solid black !important;
    border-bottom: 1px solid black !important;
}
</style>